import { getGlobalHeadersAsObject } from "../global-headers";

export interface ContactInfoTngQueueItem {
	id: number;
	created: string;
	priority: number;
	type: string;
	profile_type: number;
	object_id: number;
	person_id: number | null;
	bot_name: string;
}

export interface ContactInfoTngQueueResponse {
	count: number;
	next: string | null;
	previous: string | null;
	results: ContactInfoTngQueueItem[];
}

export interface ContactInfoTngBinaryEntry {
	id: number;
	person_id: number;
	created: string;
	extracted: boolean;
	bot_name: string;
}

export interface ContactInfoTngBinaryResponse {
	count: number;
	next: string | null;
	previous: string | null;
	results: ContactInfoTngBinaryEntry[];
}

export const fetchContactInfoTngQueue = async (
	limit: number = 100,
	offset: number = 0,
	personId?: number,
	user?: string[]
): Promise<ContactInfoTngQueueResponse> => {
	let url = `/api/v2/contactinfo-tng-queue/?limit=${limit}&offset=${offset}`;
	if (personId) {
		url += `&object_id=${personId}`;
	}
	if (user && user.length > 0) {
		url += `&user=${user.join(",")}`;
	}
	const response = await fetch(url, {
		headers: { ...getGlobalHeadersAsObject() },
	});
	if (!response.ok) {
		throw new Error(
			`Failed to fetch ContactInfo TNG queue: ${response.statusText}`
		);
	}
	return response.json();
};

export const getContactInfoTngQueueUsers = async (): Promise<string[]> => {
	const response = await fetch("/api/v2/contactinfo-tng-queue/users/", {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	});
	if (!response.ok) {
		throw new Error(`Failed to fetch users: ${response.statusText}`);
	}
	return response.json();
};

export const deleteContactInfoTngQueueItem = async (itemId: number): Promise<void> => {
	const response = await fetch(`/api/v2/contactinfo-tng-queue/${itemId}/`, {
		method: "DELETE",
		headers: { ...getGlobalHeadersAsObject() },
	});
	if (!response.ok) {
		throw new Error(`Failed to delete queue item: ${response.statusText}`);
	}
};

export const addRandomContactInfoTngQueueItem =
	async (): Promise<ContactInfoTngQueueItem> => {
		const response = await fetch("/api/v2/contactinfo-tng-queue/add-random/", {
			method: "POST",
			headers: { ...getGlobalHeadersAsObject() },
		});
		if (!response.ok) {
			const errorData = await response.json().catch(() => null);
			const errorMessage = errorData?.error || response.statusText;
			throw new Error(`Failed to add random queue item: ${errorMessage}`);
		}
		return response.json();
	};

export const fetchRecentContactInfoTngItems = async (
	limit: number = 50,
	offset: number = 0,
	personId?: number,
	user?: string[]
): Promise<ContactInfoTngBinaryResponse> => {
	let url = `/api/v2/contactinfo-tng-queue/recent-items/?limit=${limit}&offset=${offset}`;
	if (personId) {
		url += `&person_id=${personId}`;
	}
	if (user && user.length > 0) {
		url += `&user=${user.join(",")}`;
	}
	const response = await fetch(url, {
		headers: { ...getGlobalHeadersAsObject() },
	});
	if (!response.ok) {
		throw new Error(
			`Failed to fetch ContactInfo TNG items: ${response.statusText}`
		);
	}
	return response.json();
};
